import { SubBody1 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import { CancellationReason } from '@flatsy/types/Applications/CancellationReason'
import i18n from '@flatsy/utils/translations'
import { ClassNameMap } from '@material-ui/styles'

export const renderArticle = (
  classes: ClassNameMap<'padlock' | 'link' | 'text'>
): React.ReactNode => {
  return (
    <>
      <img
        src={FlatsyTheme.image.padlock}
        alt="padlock booking cancel"
        className={classes.padlock}
      />
      <SubBody1 className={classes.text}>
        {i18n.t('all_files_from_your_application_will_be_deleted_in_accordance_with')}
        <a
          href="https://www.cnil.fr/fr/reglement-europeen-protection-donnees/chapitre3#Article17"
          target="_blank"
          rel="noreferrer"
          className={classes.link}
        >
          {i18n.t('article_17_right_to_erasure')}
        </a>
        {i18n.t('right_to_be_forgottent_of_the_GDPR')}
      </SubBody1>
    </>
  )
}

export const initialValues: { [key: string]: string } = {
  [CancellationReason.unexpectedEvent]: '',
  [CancellationReason.inconvenientLocation]: '',
  [CancellationReason.foundAnotherAsset]: '',
  [CancellationReason.somethingOff]: '',
  [CancellationReason.partnerRoommate]: '',
}
